import {styled} from 'common'
import Input from 'components/Control/Input'
import Card from 'components/Display/Card'
import Button from 'components/Control/Button'
import {Texts, Colors} from 'appearance'
import Checkbox from '../Checkbox'

export const FormCard = ({children, ...p}) => {
    return <Card {...p}>{children}</Card>
}

export const FormErrorMessage = ({errors, name, errorMessage}) => {
    const passedErrorsAndHasError = errors && errors[name]
    const onlyErrorMessage = !errors && errorMessage
    if (passedErrorsAndHasError || onlyErrorMessage) {
        return <FormErrorText>{errorMessage}</FormErrorText>
    }
    return null
}

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 10px;
`

export const FormTitle = styled(Texts.Title)`
    width: 100%;
    margin-bottom: 20px;
`

export const FormInput = styled(Input)`
    /* margin-bottom: 10px; */
`

export const FormCheckbox = styled(Checkbox)`
    width: 100%;
`

export const FormRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`

export const FormActionButton = styled(Button)`
    width: 100%;
    margin-top: 30px;
    margin-bottom: 10px;
    height: 50px;
`

export const FormAdditionalButton = styled(Button)`
    margin-bottom: 10px;
`

export const FormErrorText = styled(Texts.RegularText)`
    color: ${Colors.ERROR_TEXT};
`

export const FormAdditionalText = styled(Texts.RegularText)``
